var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileIconWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.5 21.5907C16.2898 21.5907 21 16.748 21 10.7953C21 4.84271 16.2898 0 10.5 0C4.71022 0 0 4.84271 0 10.7953C0 16.748 4.71022 21.5907 10.5 21.5907ZM10.5 19.8505C8.48133 19.8505 6.62036 19.1468 5.13328 17.968C5.79374 16.4414 7.28534 15.4146 8.93577 15.4146H12.0346C13.6935 15.4146 15.191 16.4473 15.8503 17.9814C14.3661 19.1523 12.5113 19.8505 10.5 19.8505ZM7.75136 9.609C7.75136 8.05074 8.98438 6.78305 10.5 6.78305C12.0156 6.78305 13.2486 8.05074 13.2486 9.609C13.2486 11.1673 12.0156 12.4352 10.5 12.4352C8.98438 12.4352 7.75136 11.1675 7.75136 9.609ZM10.5 1.74014C15.3566 1.74014 19.3075 5.80213 19.3075 10.7953C19.3075 13.0689 18.4862 15.1479 17.1353 16.7398C16.1801 15.0142 14.4311 13.8468 12.4749 13.6931C13.9342 12.944 14.9412 11.3971 14.9412 9.609C14.9412 7.09103 12.9488 5.0429 10.5 5.0429C8.05121 5.0429 6.05882 7.09133 6.05882 9.609C6.05882 11.3959 7.06491 12.9423 8.52288 13.6919C6.56526 13.8366 4.81083 14.9994 3.85109 16.7236C2.50814 15.1336 1.69254 13.0614 1.69254 10.7953C1.69254 5.80213 5.64339 1.74014 10.5 1.74014Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIconWhite);
export default __webpack_public_path__ + "static/media/profileIconWhite.9b7a1d92e3440bb2cfa161bb0ab7f823.svg";
export { ForwardRef as ReactComponent };